import {atom} from 'recoil';

export interface ScrollPosition {
  x: number;
  y: number;
  clickedItemId?: string;
  clickedItemIndex?: number;
  timestamp?: number;
  visibleItemId?: number;
  visibleItemIndex?: number;
  scrollPercent?: number;
  viewportHeight?: number;
  contentHeight?: number;
  lastClickedItemId?: number;
}

export type ScrollPositions = Record<string, ScrollPosition>;

export const selectedBrandAtom = atom<boolean>({
  key: 'selectedBrand',
  default: false,
});

export const lastVisibleItemIdAtom = atom<string | null>({
  key: 'lastVisibleItemId',
  default: null,
});

export const scrollPositionRatioAtom = atom<number>({
  key: 'scrollPositionRatio',
  default: 0,
});

export const scrollPositionsState = atom<ScrollPositions>({
  key: 'scrollPositionsState',
  default: {},
});

export const mapLastVisibleItemIdAtom = atom<string | null>({
  key: 'MapLastVisibleItemId',
  default: null,
});

export const mapScrollPositionRatioAtom = atom<number>({
  key: 'MapScrollPositionRatio',
  default: 0,
});
